import React from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useSelector} from 'react-redux';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import fieldTooltips from '../../helpers/fieldTooltips';
import {useFormState} from 'react-final-form';
import {universalPagesValidation} from '../../helpers/universalPagesValidation';

function Slide() {
    const {values} = useFormState();
    const {limits} = useSelector(state => state.orderOptions.data);
    const {isVisible} = useFieldRules('slide');
    useSyncedField('slide', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-pages">
            <div className="form-label d-flex">
                {limits && limits.slide ? limits.slide.label : ''}
                {values && values.slide > 1 ? 's' : ''}
                <InfoTooltip>
                    <p>{fieldTooltips.slide}</p>
                </InfoTooltip>
            </div>
            <CountField
                name="slide"
                validate={universalPagesValidation('slide')}
            />
        </div>
    );
}

export default Slide;
